import { gql } from "@apollo/client";

export const GET_INT_ENUM_VALUES = gql`
  query GetIntEnumValues($enumType: IntEnumTypeName!) {
    getIntEnumValues(enumType: $enumType) {
      name
      value
    }
  }
`;

export const GET_STRING_ENUM_VALUES = gql`
  query GetStringEnumValues($enumType: StringEnumTypeName!) {
    getStringEnumValues(enumType: $enumType) {
      name
      value
    }
  }
`;

export interface IntEnumValueType {
    name: string;
    value: number;
}

export interface StringEnumValueType {
    name: string;
    value: string;
}

export interface GetIntEnumValuesResponse {
    getIntEnumValues: IntEnumValueType[];
}

export interface GetStringEnumValuesResponse {
    getStringEnumValues: StringEnumValueType[];
}
